import { ThemeContext } from "@emotion/react";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import { Box, Button, Collapse, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material"
import React, { useContext, useState } from "react";
import { ReporteSegundoExistencias, ReporteTerceroExistencias } from "../../../../hooks/existencias";
import { AreaAlmacenArray } from "../../../../@enums/tipo_almacen";
import moment from "moment";
import { MovStatusArray } from "../../../../@enums/status_mov_inv";
import { useNavigate } from "react-router-dom";


export const TablaReportesAlmacen = ({ sample, where, setAyudasVisuales, setOpenAyudas }) => {

  const theme = useContext(ThemeContext);
  const navigate = useNavigate();

  const VerSerial = ({ data }) => {
    const seriales = data;

    const Title = () => {

      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          {seriales.map(item => (
            <span>{item}</span>
          ))}
        </div>
      )
    }

    return (
      <Tooltip title={<Title />} placement="top" arrow>
        <Button variant="text">Ver Seriales</Button>
      </Tooltip>
    )
  }

  const SubRow = (props) => {
    let { mov, part_id } = props;
    const { reporteTerceroExistenciasMutation } = ReporteTerceroExistencias();
    const [openThird, setOpenThird] = useState(false);
    const [movsTag, setMovsTag] = useState([]);

    const get_movimientos = () => {
      let body = {
        almacenes: [mov?.alma_id],
        status: where?.status,
        partes: [part_id],
        fecha_inicio: null,
        fecha_fin: null,
      }
      reporteTerceroExistenciasMutation(body, {
        onSuccess: (data) => {
          if (data?.success) {
            setMovsTag(data?.data)
          }
        },
        onError: (error) => {
          console.log(error)
        }
      })
    }
    const open_sub_subtabla = () => {
      if (openThird) {
        setOpenThird(!openThird);
        setMovsTag([]);
      } else {
        get_movimientos()
        setOpenThird(!openThird);
      }
    }
    const go_trazabilidad = (tag) => {
      navigate(`/reportes/trazabilidad?etiqueta=${tag}`);
    }

    return (
      <React.Fragment>
        <TableRow key={mov?.moin_id}>
          {/* <TableCell align="center" sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>{mov?.moin_serial.length === 1 ? mov?.moin_serial[0] : <VerSerial key={`serial_${mov?.moin_id}`} data={mov?.moin_serial} />}</TableCell> */}
          <TableCell sx={{ p: 1 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => open_sub_subtabla(mov?.alma_id, part_id)}
            >
              {openThird ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell align="center" >{mov?.alma_nombre}</TableCell>
          <TableCell align="center" >{AreaAlmacenArray.find(alm => alm.id === mov.alma_area).name}</TableCell>
          <TableCell align="center" >{mov?.cantidad}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0, marginBottom: 10 }} colSpan={12}>
            <Collapse in={openThird} timeout="auto" unmountOnExit sx={{ width: '100%' }}>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Desgloce de en etiquetas
                </Typography>
                <Table size="small" aria-label="purchases" sx={{ width: '100%' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Serial</TableCell>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Etiqueta</TableCell>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Master</TableCell>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Cantidad</TableCell>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Fecha Reporteo</TableCell>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Fecha Impresion</TableCell>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Usuario Reporteo</TableCell>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Estatus</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {movsTag?.map((movTag) => (
                      <TableRow key={movTag?.etiq_codigo}>
                        <TableCell align="center" >{movTag?.serial}</TableCell>
                        <TableCell align="center" >{movTag?.etiq_codigo}</TableCell>
                        <TableCell align="center" >{movTag?.etiq_padre}</TableCell>
                        <TableCell align="center" >{movTag?.cantidad}</TableCell>
                        <TableCell align="center" >{moment(movTag?.moin_fecharegistro).local().format('DD/MM/YYYY HH:mm:ss A')}</TableCell>
                        <TableCell align="center" >{moment(movTag?.etiq_fechaimpresion).local().format('DD/MM/YYYY HH:mm:ss A')}</TableCell>
                        <TableCell align="center" >{movTag?.usu_id}</TableCell>
                        <TableCell align="center" >{MovStatusArray.find(movStatus => movStatus.id === movTag?.moin_estatus).name}</TableCell>
                        <TableCell align="center" sx={{cursor: 'pointer'}} onClick={()=>go_trazabilidad(movTag?.etiq_codigo)} >Ver trazabilidad</TableCell>
                      </TableRow>
                    )
                    )
                    }
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    )
  }

  const Row = (props) => {
    const { row } = props;
    const { part_id, part_nombre, codigo_entrada, codigo_salida, codigo_alterno, codigo_contpaq, emp_razonsocial, cantidad } = row;
    const [open, setOpen] = useState(false);
    const { reporteSegundoExistenciasMutation } = ReporteSegundoExistencias();
    const [movimientos, setMovimientos] = useState([]);

    const get_movimientos = (part_id) => {
      let body = {
        almacenes: where?.almacenes,
        status: where?.status,
        partes: [part_id],
        fecha_inicio: null,
        fecha_fin: null,
      }
      reporteSegundoExistenciasMutation(body, {
        onSuccess: (data) => {
          if (data?.success) {
            setMovimientos(data?.data)
          }
        },
        onError: (error) => {
          console.log(error)
        }
      })
    }
    const open_subtabla = (id_parte) => {
      if (open) {
        setOpen(!open);
        setMovimientos([]);
      } else {
        get_movimientos(id_parte)
        setOpen(!open);
      }
    }
    const getResources = (id) => {
      setAyudasVisuales(id);
      setOpenAyudas(true);
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 1 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => open_subtabla(part_id)}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1
            }}
            onClick={
              () => getResources(
                part_id
              )
            }
          >
            {part_nombre}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1
            }}
            onClick={
              () => getResources(
                part_id
              )
            }
          >
            {codigo_entrada}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1
            }}
            onClick={
              () => getResources(
                part_id
              )
            }
          >
            {codigo_salida}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1
            }}
            onClick={
              () => getResources(
                part_id
              )
            }
          >
            {codigo_alterno}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1
            }}
            onClick={
              () => getResources(
                part_id
              )
            }
          >
            {codigo_contpaq}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1
            }}
            onClick={
              () => getResources(
                part_id
              )
            }
          >
            {emp_razonsocial}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1
            }}
            onClick={
              () => getResources(
                part_id
              )
            }
          >
            {cantidad}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0, marginBottom: 10 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit sx={{ width: '100%' }}>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Desgloce de en almacenes
                </Typography>
                <Table size="small" aria-label="purchases" sx={{ width: '100%' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Almacén</TableCell>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Área</TableCell>
                      <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}>Cantidad</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {movimientos?.map((mov) => (
                      <SubRow key={`subrow_${part_id}_${mov?.alma_id}`} mov={mov} part_id={part_id} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }


  return (
    <>
      <Paper sx={{ boxShadow: "none", mb: 2, width: '100%' }}>
        <TableContainer component={Paper} sx={{ mt: 3 }}>
          <Table aria-label="collapsible table">
            <TableHead
              sx={{
                display: "table-head",
                backgroundColor: theme.palette.primary.main,
                fontWeight: 600,
              }}
            >
              <TableRow>
                <TableCell />
                <TableCell align="center" sx={{ color: "white" }}>
                  Parte
                </TableCell>
                <TableCell align="center" sx={{ color: "white" }}>
                  Código entrada
                </TableCell>
                <TableCell align="center" sx={{ color: "white" }}>
                  Código salida
                </TableCell>
                <TableCell align="center" sx={{ color: "white" }}>
                  Código alterno
                </TableCell>
                <TableCell align="center" sx={{ color: "white" }}>
                  Código contpaq
                </TableCell>
                <TableCell align="center" sx={{ color: "white" }}>
                  Cliente
                </TableCell>
                <TableCell align="center" sx={{ color: "white" }}>
                  Cantidad
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sample.map((row) => (
                <Row key={row?.part_id} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  )

}